import React, { useEffect, useState } from "react";
import Header from "../ShareElements/ContentHeader/ContentHeader";
import Circle from "../../../../Assets/Images/sm-Circle.svg";
import "../../../../Assets/Styles/EditProfile.scss";
import { Config } from "../../../../Config";
import axios from "axios";
import EditPreferences from "./Components/Preferences/EditPreferences";
import EditNotifications from "./Components/Notifications/EditNotifications";
import MobileNavMenu from "./Components/Preferences/Components/MobileNavMenu";
import AccountSettings from "./Components/AccountSettings/AccountSettings";
import { translateText } from "../../../../Helper_functions";
import UnsavedChangesAlert from "../../Components/ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";

const EditProfile = (props) => {
  const [UserPositionInfo, setUserPositionInfo] = useState();
  const [TabIds] = useState([
    "pref-nav-item",
    "notif-nav-item",
    "account-nav-item",
  ]);
  const [SelectedTab, setSelectedTab] = useState("pref-nav-item"); // is either pref-nav-item or notif-nav-item
  const [MobileNavIsOpen, setMobileNavIsOpen] = useState(false);
  const [HasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [UnsavedModalIsOpen, setUnsavedModalIsOpen] = useState(false);
  const [LastTabClicked, setLastTabClicked] = useState();
  const [SaveAndLeaveIsOn, setSaveAndLeaveIsOn] = useState(false); // determines if save and leave option is selected on the unsaved changes modal, used to navigate after saving is done on each tab/form
  const [LastPreferencesTabClicked, setLastPreferencesTabClicked] = useState();
  const [WillReturnToHomePage, setWillReturnToHomePage] = useState(false);
  const [ModalTypeIsCancel, setModalTypeIsCancel] = useState(false);
  const [CancelConfirmed, setCancelConfirmed] = useState(false);
  const [ResetPassFormIsShown, setResetPassFormIsShown] = useState(true);

  useEffect(() => {
    fetchEmpPositionInfo();
    handleInitialTab();
    return () => {
      window.localStorage.removeItem("IsEditNotifications");
    };
  }, []);

  const handleInitialTab = () => {
    if (window.localStorage.getItem("IsEditNotifications") === "1") {
      document.getElementById("notif-nav-item").click();
    }
  };

  const fetchEmpPositionInfo = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/current-position",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setUserPositionInfo(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const validateNavigation = (RequestedNav) => {
    setModalTypeIsCancel(false);
    setLastTabClicked(RequestedNav);

    if (HasUnsavedChanges) {
      setUnsavedModalIsOpen(true);
    } else {
      setSelectedTab(RequestedNav);
      handleMainNavigation(RequestedNav);
    }
  };
  const handleMainNavigation = (RequestedNav) => {
    TabIds.map((Tab) => {
      document.getElementById(Tab).classList.remove("active-navigate-item");
    });
    document.getElementById(RequestedNav).classList.add("active-navigate-item");
    if (RequestedNav === "pref-nav-item") {
      document
        .getElementById("edit-profile-navigation-indicator")
        .classList.remove("translated");
      document
        .getElementById("edit-profile-navigation-indicator")
        .classList.remove("translated-further");
    } else if (RequestedNav === "notif-nav-item") {
      document
        .getElementById("edit-profile-navigation-indicator")
        .classList.remove("translated-further");
      document
        .getElementById("edit-profile-navigation-indicator")
        .classList.add("translated");
    } else {
      document
        .getElementById("edit-profile-navigation-indicator")
        .classList.remove("translated");
      document
        .getElementById("edit-profile-navigation-indicator")
        .classList.add("translated-further");
    }
  };
  const displayFullName = (FullName) => {
    if (FullName.length <= 16) {
      return FullName;
    } else {
      let Short = FullName.slice(0, 14) + " ...";
      return (
        <React.Fragment>
          {Short}
          <p className="popup-text">{FullName}</p>
        </React.Fragment>
      );
    }
  };
  const displayPosTitle = (PosTitle) => {
    if (PosTitle.length <= 33) {
      return <p className="pos-title">{PosTitle}</p>;
    } else {
      let Short = PosTitle.slice(0, 30) + " ...";
      return (
        <p className="pos-title">
          {Short}
          <p className="popup-text">{PosTitle}</p>
        </p>
      );
    }
  };

  const displayNavTitle = () => {
    if (SelectedTab === "notif-nav-item") {
      return translateText("notification_settings", props.LangData);
    } else if (SelectedTab === "pref-nav-item") {
      return translateText("preferences_and_skills", props.LangData);
    } else {
      return translateText("account_settings", props.LangData);
    }
  };

  // This function is invoked in the view of the component and it displays the
  // currently selected nav item in edit profile based on the value of a state
  // item named `SelectedTab`. There are only 3 possible cases (see state item
  // named : `TabIds`)
  const displayCurrentTabContent = () => {
    // "Preferences and skills nav item"
    if (SelectedTab === "pref-nav-item") {
      return (
        <EditPreferences
          LangData={props.LangData}
          HasUnsavedChanges={HasUnsavedChanges}
          SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
          DisplayUnsavedChangesModal={(Bool) => setUnsavedModalIsOpen(Bool)}
          SetPrefTabClicked={(Id) => setLastPreferencesTabClicked(Id)}
          SaveAndLeaveIsOn={SaveAndLeaveIsOn}
          SetSaveAndLeaveIsOn={(Bool) => setSaveAndLeaveIsOn(Bool)}
          NavigateToSelectedTabAfterSave={() => navigateToTabAfterSave()}
          SetWillReturnToHomePage={(Bool) => setWillReturnToHomePage(Bool)}
          ResetLastTabInfo={() => setLastTabClicked(undefined)}
          ModalTypeIsCancel={ModalTypeIsCancel}
          SetModalTypeIsCancel={(Bool) => setModalTypeIsCancel(Bool)}
          CancelConfirmed={CancelConfirmed}
        />
      );
    } else if (SelectedTab === "account-nav-item") {
      // "Account settings nav item"
      return (
        <AccountSettings
          LangData={props.LangData}
          UserInfo={props.UserInfo}
          HasUnsavedChanges={HasUnsavedChanges}
          SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
          DisplayUnsavedChangesModal={(Bool) => setUnsavedModalIsOpen(Bool)}
          SaveAndLeaveIsOn={SaveAndLeaveIsOn}
          SetSaveAndLeaveIsOn={(Bool) => setSaveAndLeaveIsOn(Bool)}
          NavigateToSelectedTabAfterSave={() => navigateToTabAfterSave()}
          SetWillReturnToHomePage={(Bool) => setWillReturnToHomePage(Bool)}
          ModalTypeIsCancel={ModalTypeIsCancel}
          SetModalTypeIsCancel={(Bool) => setModalTypeIsCancel(Bool)}
          CancelConfirmed={CancelConfirmed}
          ResetPassFormIsShown={ResetPassFormIsShown}
        />
      );
    } else {
      // "Notofications nav item"
      return (
        <EditNotifications
          LangData={props.LangData}
          HasUnsavedChanges={HasUnsavedChanges}
          SetHasUnsavedChanges={(Bool) => setHasUnsavedChanges(Bool)}
          DisplayUnsavedChangesModal={(Bool) => setUnsavedModalIsOpen(Bool)}
          SaveAndLeaveIsOn={SaveAndLeaveIsOn}
          SetSaveAndLeaveIsOn={(Bool) => setSaveAndLeaveIsOn(Bool)}
          NavigateToSelectedTabAfterSave={() => navigateToTabAfterSave()}
          SetWillReturnToHomePage={(Bool) => setWillReturnToHomePage(Bool)}
          ModalTypeIsCancel={ModalTypeIsCancel}
          SetModalTypeIsCancel={(Bool) => setModalTypeIsCancel(Bool)}
          CancelConfirmed={CancelConfirmed}
        />
      );
    }
  };

  const navigateToTabAfterSave = () => {
    if (HasUnsavedChanges) {
      setHasUnsavedChanges(false);
    }

    setTimeout(() => {
      if (WillReturnToHomePage) {
        document.getElementById("link-to-home").click();
      } else {
        if (LastTabClicked === undefined) {
          document.getElementById(LastPreferencesTabClicked).click();
        } else {
          document.getElementById(LastTabClicked).click();
        }
      }
    }, 500);
  };

  const saveAndLeave = () => {
    window.localStorage.setItem("HasUnsaveChanges", "0");
    setSaveAndLeaveIsOn(true);
    setUnsavedModalIsOpen(false);

    if (MobileNavIsOpen) {
      setMobileNavIsOpen(false);
    }

    setTimeout(() => {
      document.getElementById("save-btn").click();
    }, 500);
  };

  const discardAndLeave = () => {
    window.localStorage.setItem("HasUnsaveChanges", "0");
    setHasUnsavedChanges(false);
    setUnsavedModalIsOpen(false);

    if (MobileNavIsOpen) {
      setSelectedTab(LastTabClicked);
      setMobileNavIsOpen(false);
    }

    navigateToTabAfterSave();
  };

  const toggleAcceptCancel = () => {
    setUnsavedModalIsOpen(false);
    setModalTypeIsCancel(false);
    setCancelConfirmed(!CancelConfirmed);

    setResetPassFormIsShown(false); // Only used in the account settings form to unmount and then mount the components to reset their values
    setTimeout(() => {
      setResetPassFormIsShown(true);
    }, 100);
  };

  const handleCloseCancelModal = () => {
    setHasUnsavedChanges(true);
    setUnsavedModalIsOpen(false);
    setModalTypeIsCancel(false);
  };

  return (
    <div className="main-content">
      {UnsavedModalIsOpen ? (
        <>
          {ModalTypeIsCancel ? (
            <UnsavedChangesAlert
              close={() => handleCloseCancelModal()}
              LangData={props.LangData}
              saveAndLeave={() => saveAndLeave()}
              discardAndLeave={() => discardAndLeave()}
              AlertMessage="You have unsaved changes: If you cancel, your changes will be discarded."
              // CancelText={translateText("cancel", props.LangData)}
              CancelText={"Keep editing"}
              SaveText={translateText("discard", props.LangData)}
              save={() => toggleAcceptCancel()}
              ReverseBTNs={true}
            />
          ) : (
            <UnsavedChangesAlert
              close={() => setUnsavedModalIsOpen(false)}
              LangData={props.LangData}
              saveAndLeave={() => saveAndLeave()}
              discardAndLeave={() => discardAndLeave()}
            />
          )}
        </>
      ) : null}
      <Header PageName={translateText("edit_profile", props.LangData)} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("home", props.LangData)}</p>
          <img src={Circle} alt="." />
          <p>{translateText("edit_profile", props.LangData)}</p>
        </div>
      </div>

      <div className="mobile-navigator is-mobile">
        <i
          className="feather-arrow-left"
          onClick={() => document.getElementById("link-to-home").click()}
        ></i>
        <section
          className="mobile-edit-ptofile-trigger"
          onClick={() => setMobileNavIsOpen(!MobileNavIsOpen)}
        >
          <p>{displayNavTitle()}</p>
          <i
            className={
              MobileNavIsOpen
                ? "feather-chevron-down rotated-icon"
                : "feather-chevron-down"
            }
          ></i>
        </section>
      </div>
      <div className="content-body edit-profile-wrapper">
        {MobileNavIsOpen ? (
          <MobileNavMenu
            CloseMenu={() => setMobileNavIsOpen(false)}
            SelectedTab={SelectedTab}
            SetSelectedTab={(TabId) => setSelectedTab(TabId)}
            LangData={props.LangData}
            HasUnsavedChanges={HasUnsavedChanges}
            DisplayUnsavedChangesModal={(Bool) => setUnsavedModalIsOpen(Bool)}
            SetLastTabClicked={(Id) => setLastTabClicked(Id)}
          />
        ) : null}
        <div
          className={
            SelectedTab === "pref-nav-item"
              ? "sm-column"
              : "sm-column less-margined-mobile"
          }
        >
          <section className="sm-coulmn-head">
            {props.UserInfo.imageThumbnailUrl === null ? (
              <span
                className="user-avatar"
                style={{
                  backgroundColor: props.UserInfo.backgroundColorCode,
                  color: props.UserInfo.textColorCode,
                }}
              >
                {props.UserInfo.firstName.slice(0, 1).toUpperCase() +
                  props.UserInfo.lastName.slice(0, 1).toUpperCase()}
              </span>
            ) : (
              <img
                className="user-avatar"
                src={props.UserInfo.imageThumbnailUrl}
                loading="lazy"
              />
            )}
            <span className="user-info-sum">
              <h1>
                {displayFullName(
                  props.UserInfo.firstName + " " + props.UserInfo.lastName
                )}
              </h1>
              {UserPositionInfo === undefined ||
              UserPositionInfo.title === null ? null : (
                <>{displayPosTitle(UserPositionInfo.title)}</>
              )}
            </span>
          </section>
          <section className="edit-profile-nav">
            <span
              id="pref-nav-item"
              className="navigate-item active-navigate-item"
              onClick={() => validateNavigation("pref-nav-item")}
            >
              <i className="feather-sliders"></i>
              <p>{translateText("preferences_and_skills", props.LangData)}</p>
            </span>
            <span
              id="notif-nav-item"
              className="navigate-item"
              onClick={() => validateNavigation("notif-nav-item")}
            >
              <i className="feather-bell"></i>
              <p>{translateText("notifications", props.LangData)}</p>
            </span>
            <span
              id="account-nav-item"
              className="navigate-item"
              onClick={() => validateNavigation("account-nav-item")}
            >
              <i className="feather-user"></i>
              <p>{translateText("account_settings", props.LangData)}</p>
            </span>
            <span id="edit-profile-navigation-indicator"></span>
          </section>
        </div>
        <>{displayCurrentTabContent()}</>
      </div>
    </div>
  );
};

export default EditProfile;
